class StoreLocator extends HTMLElement {
	constructor() {
		super();
		this.map = null;
		this.currentMarker = null;
		this.storeItems = [];
		this.markerColor = 'white';
	}

	connectedCallback() {
		this.storeItems = this.querySelectorAll('.store-locator__item');
		const listEl = this.querySelector('.store-locator__list');
		this.markerColor = listEl?.dataset.markerColor || 'white';
	
		const defaultLat = 40.7128;
		const defaultLng = -74.0060;
	
		const firstStoreItem = this.storeItems[0];
		const initialLat = firstStoreItem?.dataset.latitude ? parseFloat(firstStoreItem.dataset.latitude) : defaultLat;
		const initialLng = firstStoreItem?.dataset.longitude ? parseFloat(firstStoreItem.dataset.longitude) : defaultLng;
	
		const mapEl = this.querySelector('#map');
		if (!mapEl) {
			console.error('Map element not found in store-locator');
			return;
		}
	
		this.map = L.map(mapEl, {
			zoomControl: false
		}).setView([initialLat, initialLng], 14);
	
		const customIcon = L.icon({
			iconUrl: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(this.generateSVG(this.markerColor)),
			iconSize: [35, 40],
			iconAnchor: [16, 32],
			popupAnchor: [0, -32]
		});
	
		this.currentMarker = L.marker([initialLat, initialLng], { icon: customIcon }).addTo(this.map);
	
		L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
			maxZoom: 20
		}).addTo(this.map);
	
		this.lastOpenedItem = Array.from(this.storeItems).find(item => item.hasAttribute('open'));
	
		this.storeItems.forEach(storeItem => {
			storeItem.addEventListener('toggle', () => {
				if (storeItem.hasAttribute('open')) {
					if (this.lastOpenedItem && this.lastOpenedItem !== storeItem) {
						this.lastOpenedItem.removeAttribute('open');
					}
					this.lastOpenedItem = storeItem;
	
					const lat = parseFloat(storeItem.dataset.latitude);
					const lng = parseFloat(storeItem.dataset.longitude);
					
					if (!isNaN(lat) && !isNaN(lng)) {
						this.map.setView([lat, lng], 14);
						this.currentMarker.setLatLng([lat, lng]);
					}
				}
			});
		});
	}
	

	generateSVG(color) {
		return `
			<svg width="46" height="55" viewBox="0 0 46 55" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M14 23.5C14 21.2457 14.8955 19.0837 16.4896 17.4896C18.0837 15.8955 20.2457 15 22.5 15C24.7543 15 26.9163 15.8955 28.5104 17.4896C30.1045 19.0837 31 21.2457 31 23.5C31 25.7543 30.1045 27.9163 28.5104 29.5104C26.9163 31.1045 24.7543 32 22.5 32C20.2457 32 18.0837 31.1045 16.4896 29.5104C14.8955 27.9163 14 25.7543 14 23.5Z" fill="${color}"/>
				<path fill-rule="evenodd" clip-rule="evenodd" d="M1.68463 20.9529C2.10777 15.8563 4.43764 11.1044 8.21203 7.64C11.9864 4.17556 16.9296 2.25166 22.0608 2.25H23.1597C28.2909 2.25166 33.2341 4.17556 37.0084 7.64C40.7828 11.1044 43.1127 15.8563 43.5358 20.9529C44.0054 26.6431 42.2428 32.2931 38.6186 36.7148L26.426 51.5767C25.9639 52.1404 25.3818 52.5947 24.7218 52.9066C24.0619 53.2186 23.3406 53.3804 22.6102 53.3804C21.8798 53.3804 21.1586 53.2186 20.4986 52.9066C19.8387 52.5947 19.2566 52.1404 18.7945 51.5767L6.60442 36.7148C2.97935 32.2935 1.2158 26.6434 1.68463 20.9529ZM22.6102 11.7574C19.4056 11.7574 16.3322 13.0261 14.0661 15.2846C11.8001 17.543 10.527 20.6061 10.527 23.8C10.527 26.9939 11.8001 30.057 14.0661 32.3154C16.3322 34.5739 19.4056 35.8427 22.6102 35.8427C25.8149 35.8427 28.8883 34.5739 31.1544 32.3154C33.4204 30.057 34.6935 26.9939 34.6935 23.8C34.6935 20.6061 33.4204 17.543 31.1544 15.2846C28.8883 13.0261 25.8149 11.7574 22.6102 11.7574Z" fill="${color}"/>
			</svg>
		`;
	}
}

customElements.define('store-locator', StoreLocator);
